import { render, staticRenderFns } from "./toggleHeader.vue?vue&type=template&id=08ef40fd&scoped=true&"
import script from "./toggleHeader.vue?vue&type=script&lang=js&"
export * from "./toggleHeader.vue?vue&type=script&lang=js&"
import style0 from "./toggleHeader.vue?vue&type=style&index=0&id=08ef40fd&prod&scoped=true&lang=scss&"
import style1 from "./toggleHeader.vue?vue&type=style&index=1&id=08ef40fd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ef40fd",
  null
  
)

export default component.exports